import { render, staticRenderFns } from "./releaseDemand.vue?vue&type=template&id=375a9976&scoped=true&"
import script from "./releaseDemand.vue?vue&type=script&lang=js&"
export * from "./releaseDemand.vue?vue&type=script&lang=js&"
import style0 from "./releaseDemand.vue?vue&type=style&index=0&id=375a9976&prod&scoped=true&lang=css&"
import style1 from "./releaseDemand.vue?vue&type=style&index=1&id=375a9976&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a9976",
  null
  
)

export default component.exports